import {
	IScaleRange,
	IRangeData,
} from 'modules/admin-panel/pages/results/models';

export const getScaleRange = (data: IRangeData): IScaleRange => {
	return {
		negative: {
			min: data.minOfNegativeRange,
			max: data.maxOfNegativeRange,
		},
		neutral: {
			min: data.minOfNeutralRange,
			max: data.maxOfNeutralRange,
		},
		positive: {
			min: data.minOfPositiveRange,
			max: data.maxOfPositiveRange,
		},
	};
};
